/*
Created by: Alby Anna Ulahannan
Created on: 06-09-2024
Page Description: This page implements the change password functionality for the Al Mal Capital web application.
Users can enter a new password and confirm it to reset their password. 
The new password must be at least 8 characters long, include an uppercase letter, a number, and a special character.
Error messages are displayed for invalid password input or if passwords do not match.
*/

import React, { useEffect, useState } from "react";
import Eye from "../images/eye.png"
import HideEye from "../images/hide.png"
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';
import { callingAPIWithoutAuthForgotPassword } from "../service"

export default function ChangePassword({ setShowForgotPassword, userId }) {

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [isPasswordVisibleNew, setIsPasswordVisibleNew] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState("");
    const maxlength = newPassword.length >= 12
    const minLength = newPassword.length >= 10;
    const hasUppercase = /[A-Z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);

    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };
    const togglePasswordVisibilityNew = () => {
        setIsPasswordVisibleNew(!isPasswordVisibleNew);
    };
    useEffect(() => {
        if (newPassword !== "" && newPassword.length >= 8) {
            const strength1 = validatePasswordStrength(newPassword);
            setPasswordStrength(strength1);
        }
        else {
            setError("");
            setPasswordStrength("");
        }
    }, [newPassword]);

    const validatePasswordStrength = (password) => {
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        if (maxlength === true && hasUppercase && hasNumber && hasSpecialChar) {
            return "strong";
        } else if (minLength === true && (hasUppercase || hasNumber || hasSpecialChar)) {
            return "medium";
        } else {
            return "weak";
        }
    };

    const validateForm = () => {
        const maxlength = newPassword.length >= 8
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
        if (newPassword === "") {
            setError("Enter New Password");
            return false;
        }
        else if (maxlength == false || !hasUppercase || hasNumber == false || !hasSpecialChar) {
            setError("Invalid Password");
            return false;
        }
        else if (confirmPassword === "") {
            setError("Enter Confirm Password");
            return false;
        }
        else if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return false;
        }
        else {
            setError("");
            return true;
        }
    };


    const handleChangePassword = () => {
        if (validateForm()) {
            const postData = {
                userId: userId,
                password: confirmPassword
            };
            console.log("🚀 ~ handleChangePassword ~ postData:", postData)
            callingAPIWithoutAuthForgotPassword(postData, "user/resetPassword", 'post')
                .then((response) => {
                    const { data } = response;

                    if (data.statusCode === 200) {
                        console.log('Password changed successfully', data.statusCode);

                        // navigate('/dashboard');
                        setPasswordChanged(true);
                        sessionStorage.removeItem("resetToken");
                    } else {
                        console.error('Password change failed with status code:', data.statusCode);
                        setError(data.message);
                        setPasswordChanged(false);
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        const { message, statusCode } = error.response.data;
                        console.error('Error during password change:', statusCode, message);
                        setError(message);
                    } else {
                        console.error('Error during password change:', error);
                        setError(error);
                    }
                });
        }
    };

    const handleBackToLogin = () => {
        setShowForgotPassword(false);
    };

    return (

        <>


            <div className="login-form-wrap">
                <h1 className="login-head mb-3 mt-4">Change Password</h1>
                {/* <p className="login-para">
                Your password has expired. Please reset your password.
            </p> */}

                {passwordChanged ? (
                    <div className="my-5 text-center">
                        <p className="passwrd-success-msg">
                            Password changed successfully. <br />
                            Please <span className="login-link" onClick={handleBackToLogin}>Click here</span> to Login.
                        </p>
                    </div>
                ) : (
                    <div className="col-12 position-relative">
                        <div className="d-flex justify-content-center">
                            {error && <p className="err-msg-text err-msg-text-top">{error}</p>}</div>
                        <div className="form-labels-outer mb-1">
                            <label htmlFor="newPassword" className="form-label">New Password</label>
                            <div className="Right-Icon">
                                <input
                                    id="newPassword"
                                    type={isPasswordVisibleNew ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Enter New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <div className="eye-show" onClick={togglePasswordVisibilityNew}>
                                    <img
                                        src={isPasswordVisibleNew ? HideEye : Eye}
                                        alt="Toggle Password Visibility"
                                        className="img-fluid"
                                        width="15"
                                        height="15"
                                    />
                                </div>

                                {passwordStrength === "weak" && (
                                    <>
                                        <div className="d-flex" style={{ gap: "7px" }}>
                                            <div className="bar-weak"></div>
                                            <div className="bar-default"></div>
                                            <div className="bar-default"></div>
                                        </div>
                                        <div className="pass-valid-text color-red">Weak</div>
                                    </>
                                )}

                                {passwordStrength === "medium" && (
                                    <>
                                        <div className="d-flex" style={{ gap: "7px" }}>
                                            <div className="bar-medium"></div>
                                            <div className="bar-medium"></div>
                                            <div className="bar-default"></div>
                                        </div>
                                        <div className="pass-valid-text color-yellow">Medium</div>
                                    </>
                                )}

                                {passwordStrength === "strong" && (
                                    <>
                                        <div className="d-flex" style={{ gap: "7px" }}>
                                            <div className="bar-strong"></div>
                                            <div className="bar-strong"></div>
                                            <div className="bar-strong"></div>
                                        </div>
                                        <div className="pass-valid-text color-green">Strong</div>
                                    </>
                                )}
                            </div>
                        </div>
                        <p className="change-passwrd-text mb-1">Password must be at least 8 characters long, include an uppercase letter, a number, and a special character. Password must be different from your last 5 passwords.</p>
                        <div className="form-labels-outer mb-2">
                            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                            <div className="Right-Icon">
                                <input
                                    autoComplete="off"
                                    id="confirmPassword"
                                    type={isPasswordVisible ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Enter Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <div className="eye-show" onClick={togglePasswordVisibility}>
                                    <img
                                        src={isPasswordVisible ? HideEye : Eye}
                                        alt="Toggle Password Visibility"
                                        className="img-fluid"
                                        width="15"
                                        height="15"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <p className="change-passwrd-text">Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.</p> */}

                        <div>
                            <button className="btn btn-login btn-block" onClick={handleChangePassword}>Submit</button>
                        </div>
                        <div className="forgot-pass-sec">
                            <a className="forgot-passtext" onClick={handleBackToLogin}>Back To Login</a>
                        </div>
                    </div>
                )}

            </div>



        </>

    )
}
